import React from "react";
import { thhiyaAdvantageData } from "./data";
import "../assests/CSS/AboutComponent5.css";

const AboutComponent5 = () => {
  return (
    <section className="advantage-section">
      <h2 className="advantage-title">The <span style={{ color: "#000", fontWeight: "bold" }}>Thhiya</span><span style={{ color: "red", fontSize: "2rem" }}>.</span> Advantage</h2>
      <div className="advantage-grid">
        {thhiyaAdvantageData.map((item) => (
          <div key={item.id} className="advantage-card">
            <h3>{item.title}</h3>
            <ul>
              {item.points.map((point, index) => (
                <li key={index}>{point}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AboutComponent5;
